import { __assign, __makeTemplateObject, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import styled from '@emotion/styled';
export var BasicTableBody = styled(function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return React.createElement("tbody", __assign({}, props), children);
})(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
BasicTableBody.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
};
var templateObject_1;
//# sourceMappingURL=BasicTableBody.js.map